<script>
export default {
    name: "AutoRefreshMixin",
    data () {
        return {
            autoRefreshInterval: 0,
            autoRefreshIntervalList: [
                { text: 'off', value: 0 },
                { text: '1 minute', value: 60000 },
                { text: '5 minutes', value: 300000 },
                { text: '10 minutes', value: 600000 },
            ],
            intervalInstance: null,
        }
    },
    destroyed () {
        this.stopInterval()
    },
    methods: {
        refresh () {
            // function handle call API
        },
        stopInterval () {
            clearInterval(this.intervalInstance)
            this.intervalInstance = null
        },
    },
    watch: {
        autoRefreshInterval (autoRefreshInterval) {
            if (autoRefreshInterval === 0) {
                this.stopInterval()
                return
            }

            this.refresh()
            this.intervalInstance = setInterval(() => {
                this.refresh()
            }, this.autoRefreshInterval)
        }
    }
}
</script>
